module.exports = __webpack_public_path__ + "ab3baeeaa6a5622e8288f9069593a407.png";